import {
    IBayesianNetworksParameters,
    IResults,
    CalculationType
} from '../bayesian-networks-interfaces';
import { buildGraph, getProbabilitiesMapFromData, parseRules } from './graph-provider';
import { calculateRule } from './rules-provider';

/**
 * Formulas:
 * - Conditional probability: P(A|B) = P(A ∧ B) / P(B)
 * - Full marginal expansion: P(C) = P(C,A,B) + P(C,~A,B) + P(C, A,~B) + P(C, ~A,~B)
 * - Chain rule: P(A,B) = P(A|B) * P(B)
 */
export const calculateBayesianNetworks = (params: IBayesianNetworksParameters) : IResults [] => {
    const graph = buildGraph(params);
    parseRules(params, graph);

    const results = getProbabilitiesMapFromData(params);
    const targets = params.targets;

    const calcResults: IResults[] = [];

    for(const target of targets) {
        console.log(target)
        try{
            const steps: JSX.Element[] = [];

            const calculationTypesMap: Map<string, Set<CalculationType>> = new Map(); // rule --> used calculation types

            const probability = calculateRule(
                    results,
                    target,
                    calculationTypesMap,
                    0,
                    graph,
                    steps,
                    '#000'
                )
            ;

            steps.reverse();

            calcResults.push({
                target,
                steps,
                probability,
            });
        }
        catch(ex){
            console.log(ex.message);
        }
        console.log('---------------------------------------------------------')
        console.log();
    }

    return calcResults;
};